export function downLoadFile(data: any, type: string, name = 'file') {
  let blob = new Blob([data], { type: type });
  let url = window.URL.createObjectURL(blob);

  var a = document.createElement('a');
  a.href = url;
  a.target = '_blank';
  a.download = name;
  document.body.appendChild(a);
  a.click();
}
